<section class="column-gap-1 vertical-container-simple">

  <!-- EmptyState -->
  <ng-container *ngIf="show.loadingState">
    <div class="vertical-container-simple column-gap-1">
      <div class="main vertical-container-simple column-gap-1 height-23">
        <div class="width-100pcnt height-30 bg-black-3 br-0p5"></div>
      </div>
      <ng-container *ngFor="let i of [].constructor(5)">
        <div class="main vertical-container-simple column-gap-1">
          <div class="width-20pcnt height-1p5 bg-black-3 br-0p5"></div>
          <div class="width-100pcnt height-28p75 bg-black-3 br-0p5"></div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Components -->
  <ng-container *ngIf="!show.loadingState && selected.org">
    <div class="main">
      <app-ma-vintage-table
        [selectedOrg]="selected.org"
        [marketData]="marketAnalysisByVintageDto">
      </app-ma-vintage-table>
    </div>
    <div class="main">
      <app-moic-vintage-chart
        [data]="marketAnalysisByVintageDto.tvpiChartData"
        [selectedFundName]="selected.org.selectedFund.name"
        [chartName]="'Fund TVPI'">
      </app-moic-vintage-chart>
    </div>
    <div class="main">
      <app-moic-vintage-chart
        [data]="marketAnalysisByVintageDto.netIrrChartData"
        [selectedFundName]="selected.org.selectedFund.name"
        [chartName]="'Net IRR'" >
      </app-moic-vintage-chart>
    </div>
    <div class="main">
      <app-moic-vintage-chart
        [data]="marketAnalysisByVintageDto.moicChartData"
        [selectedFundName]="selected.org.selectedFund.name"
        [chartName]="'Portfolio MOIC'">
      </app-moic-vintage-chart>
    </div>
    <div class="main">
      <app-moic-vintage-chart
        [data]="marketAnalysisByVintageDto.grossIrrChartData"
        [selectedFundName]="selected.org.selectedFund.name"
        [chartName]="'Portfolio IRR'" >
      </app-moic-vintage-chart>
    </div>
    <div class="main">
      <app-contribution-vintage-chart
        [data]="marketAnalysisByVintageDto.contributionChartData"
        [selectedFundName]="selected.org.selectedFund.name"
        [chartName]="'Contribution & commitment'">
      </app-contribution-vintage-chart>
    </div>
  </ng-container>
</section>
